import { render, staticRenderFns } from "./wave-icon.vue?vue&type=template&id=148f255c"
import script from "./wave-icon.vue?vue&type=script&lang=js"
export * from "./wave-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports